module.exports = __webpack_public_path__ + "static/media/default.13d1ab00.jpg";